import { titleTop, navigation, mainDrawing, product, operation, clause, guarantee, claims, information, bottomButton, informationConfirmation, trial, inform, disclosureIcp, productList, queryInfo, policyCancel, policyDetail, invoiceList, invoice, invoiceRecordList, invoiceDetail } from './components';
export default {
  components: {
    titleTop,
    navigation,
    mainDrawing,
    product,
    operation,
    clause,
    guarantee,
    claims,
    information,
    bottomButton,
    informationConfirmation,
    trial,
    inform,
    disclosureIcp,
    productList,
    queryInfo,
    policyCancel,
    policyDetail,
    invoiceList,
    invoice,
    invoiceRecordList,
    invoiceDetail
  },
  props: {
    itemObj: {
      type: Object,
      default() {
        return {};
      }
    },
    itemIndex: {
      type: Number,
      default: -1
    },
    arrNum: {
      type: Number,
      default: 2
    },
    isDisplayNavigation: {
      type: Boolean,
      default: true
    },
    themeColor: {
      type: String,
      default: ''
    },
    isConfigure: {
      type: Boolean,
      default: true
    },
    pageType: {
      type: String,
      default: ''
    },
    pageDescription: {
      type: Boolean,
      default: false
    },
    pageDescriptionConfig: {
      type: Object
    }
  },
  watch: {
    itemObj: {
      handler(newObj) {
        this.styleInfo = newObj.isClick ? 'border: 1px solid #1890ff;' : '';
        this.timer1 = new Date().getTime();
        this.checkFun();
      },
      deep: true
    },
    itemIndex: {
      handler(val) {
        if (this.$route.params.type == 'DETAILS') {
          if (this.isDisplayNavigation) {
            this.upShow = val > 3 ? true : false;
            this.mainDrawingShow = this.itemObj.isClick && val > 2 ? true : false;
          } else {
            this.upShow = val > 2 ? true : false;
            this.mainDrawingShow = this.itemObj.isClick && val > 1 ? true : false;
          }
        } else {
          this.upShow = val > 1 ? true : false;
          this.mainDrawingShow = false;
        }
      },
      deep: true
    },
    arrNum: {
      handler(newArr) {
        this.downShow = this.arrNum == this.itemIndex ? false : true;
      },
      deep: true
    }
  },
  data() {
    return {
      styleInfo: '',
      style: 1,
      timer1: '',
      downShow: false,
      upShow: false,
      mainDrawingShow: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.downShow = this.arrNum == this.itemIndex ? false : true;
      this.styleInfo = this.itemObj.isClick ? 'border: 1px solid #1890ff;' : '';
      this.checkFun();
    });
  },
  methods: {
    checkFun() {
      if (this.$route.params.type == 'DETAILS') {
        if (this.isDisplayNavigation) {
          this.upShow = this.itemIndex > 3 ? true : false;
          this.mainDrawingShow = this.itemObj.isClick && this.itemIndex > 2 ? true : false;
        } else {
          this.upShow = this.itemIndex > 2 ? true : false;
          this.mainDrawingShow = this.itemObj.isClick && this.itemIndex > 1 ? true : false;
        }
      } else {
        this.upShow = this.itemIndex > 1 ? true : false;
        this.mainDrawingShow = false;
      }
    },
    itemFun() {
      this.$emit('itemClick', this.itemObj, this.itemIndex);
    },
    delItemFun() {
      this.$emit('itemDel', this.itemIndex);
    },
    upItemFun() {
      this.$emit('itemUp', this.itemIndex);
    },
    downItemFun() {
      this.$emit('itemDown', this.itemIndex);
    },
    premiumlickFun(index) {
      this.itemFun();
      this.$emit('premiumClick', index);
    },
    buttonModalClickFun(index) {
      this.itemFun();
      this.$emit('buttonModalClick', index);
    }
  }
};